import React from "react";
import "./style.scss";
import successModalIcon from "../../assets/icons/success-modal-icon.png";
import { useDispatch, useSelector } from "react-redux";
import { clearMessages } from "../../utils/store/reducers/Message";
import Spinner from "../spinner/Spinner";

const ConfirmationModal = ({
  msg,
  handleConfirm,
  title,
  handleCancel,
  isLoading,
}) => {
  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal-container">
        <div className="confirm-modal-info">
          <h2 className="modal-name">{title}</h2>
          <p className="modal-description">{msg}</p>
        </div>
        <div className="confirm-modal-button">
          <button onClick={() => handleCancel()} className="modal-button">
            Cancel
          </button>
          <button
            disabled={isLoading}
            onClick={() => handleConfirm()}
            className="modal-button"
          >
            {isLoading ? <Spinner size={30} stroke={3} /> : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
